module.exports = __webpack_public_path__ + "static/img/choose-us-3.4e27a15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/choose-us-3.png
// module id = oTCU
// module chunks = 0